/**
 * Backend API base URL for this build.
 * `ionic build` (dev) uses this file; `ionic build --configuration=live` replaces it with
 * api-base.live.ts (see angular.json). For local work, point it at your local backend,
 * e.g. 'http://localhost:3000/api/v1', and don't commit that change.
 */
export const API_BASE = 'https://dev.my-legacy.ai/api/v1';
